import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const pageVariants = {
  initial: { opacity: 0, scale: 0.96, filter: "blur(6px)" },
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: { opacity: 0, x: -60, filter: "blur(4px)" },
};
const benefits = [
  {
    icon: "🏷️",
    title: "Strengthens Brand Identity",
    desc: "Custom murals can incorporate a company's logo, mission statement, brand colors, and core values. This helps reinforce the organization's identity and creates a consistent brand experience for employees, clients, and visitors.",
  },
  {
    icon: "🚀",
    title: "Improves Employee Motivation",
    desc: "The work environment has a direct impact on employee productivity and morale. Creative and visually appealing office wall art can make employees feel more inspired, engaged, and connected to their workplace.",
  },
  {
    icon: "🤝",
    title: "Creates an Engaging Workplace",
    desc: "Blank walls often make office spaces feel dull. Custom murals add personality and energy to meeting rooms, workstations, reception areas, and breakout zones, improving collaboration and the overall employee experience.",
  },
  {
    icon: "👔",
    title: "Leaves a Lasting Impression on Clients",
    desc: "Visitors often form opinions about a business within seconds of entering an office. Professionally designed office interior murals create a modern and sophisticated appearance that reflects the company's commitment to quality.",
  },
  {
    icon: "✨",
    title: "Enhances Office Aesthetics",
    desc: "Custom murals transform ordinary office interiors into visually striking spaces. Whether it's a modern artistic design, a cityscape, or a company story wall, murals create a workspace that stands out.",
  },
];
function Blog3() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.7, ease: "easeInOut" }}
      style={{ background: "var(--canvas)", minHeight: "100vh" }}
    >
      <div
        style={{
          background:
            "linear-gradient(150deg,#1a0a2e 0%,#2a0a1e 50%,#0f0520 100%)",
          padding: "100px 6% 70px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 340,
            height: 340,
            borderRadius: "60% 40% 55% 45% / 50% 60% 40% 55%",
            background: "var(--lavender)",
            opacity: 0.1,
            top: -80,
            right: -80,
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 180,
            height: 180,
            borderRadius: "50%",
            background: "var(--coral)",
            opacity: 0.07,
            bottom: -20,
            left: 120,
          }}
        />
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            color: "#c9982a",
            fontWeight: 700,
            fontSize: "0.78rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
        >
          WORKPLACE DESIGN · OFFICE MURALS
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.8 }}
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontWeight: 900,
            fontSize: "clamp(1.8rem,5vw,3.2rem)",
            color: "#fff",
            lineHeight: 1.2,
            maxWidth: 720,
            margin: "0 auto 24px",
          }}
        >
          Benefits of Custom Murals for Office Interiors
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          style={{
            color: "rgba(255,255,255,0.55)",
            fontSize: "0.88rem",
            letterSpacing: "1px",
          }}
        >
          5 min read
        </motion.p>
      </div>
      <div
        style={{
          maxWidth: 780,
          margin: "0 auto",
          padding: "64px 6% 100px",
        }}
      >
        <p
          style={{
            fontSize: "1.1rem",
            lineHeight: 1.85,
            color: "#333",
            marginBottom: "32px",
            borderLeft: "4px solid #7c5cbf",
            paddingLeft: "20px",
            fontStyle: "italic",
          }}
        >
          Modern workplaces are no longer just spaces where employees complete
          tasks. Today's businesses focus on creating inspiring environments
          that reflect their brand, motivate teams, and leave a lasting
          impression on clients.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 16px",
          }}
        >
          Why Custom Murals Are Important for Office Spaces
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "40px" }}>
          A well-designed office mural does more than decorate a wall. It
          creates an atmosphere that reflects the company's culture, vision, and
          values. Unlike generic décor, custom murals are tailored to the
          business, making the workspace unique and memorable.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 28px",
          }}
        >
          5 Key Benefits
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {benefits.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              style={{
                display: "flex",
                gap: "20px",
                padding: "24px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
                border: "1px solid #f0ece4",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  background: "rgba(124,92,191,0.1)",
                  border: "1.5px solid rgba(124,92,191,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.4rem",
                  flexShrink: 0,
                }}
              >
                {b.icon}
              </div>
              <div>
                <strong
                  style={{
                    display: "block",
                    fontSize: "1rem",
                    fontWeight: 700,
                    color: "#1a0a2e",
                    marginBottom: "6px",
                  }}
                >
                  {b.title}
                </strong>
                <p style={{ lineHeight: 1.75, color: "#555", margin: 0 }}>
                  {b.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "56px 0 16px",
          }}
        >
          Transform Your Office with Custom Murals
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "44px" }}>
          Investing in custom office wall murals is a powerful way to enhance
          workplace aesthetics, strengthen branding, and improve employee
          engagement. With professional office mural design services, businesses
          can create inspiring interiors that support productivity and leave a
          lasting impact.
        </p>
        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <motion.button
              whileHover={{ background: "#b8882a" }}
              style={{
                padding: "13px 28px",
                background: "#c9982a",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                cursor: "pointer",
                textTransform: "uppercase",
                transition: "background 0.3s",
              }}
            >
              Get a Quote
            </motion.button>
          </Link>
          <Link to="/services/wall-murals" style={{ textDecoration: "none" }}>
            <motion.button
              whileHover={{ background: "#f0ece4" }}
              style={{
                padding: "13px 28px",
                background: "transparent",
                color: "#1a0a2e",
                border: "1.5px solid #1a0a2e",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "1px",
                cursor: "pointer",
                textTransform: "uppercase",
                transition: "background 0.3s",
              }}
            >
              View Our Work
            </motion.button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
export default Blog3;
